import { render, staticRenderFns } from "./TheCategoryTipology.vue?vue&type=template&id=2c3c5af2"
import script from "./TheCategoryTipology.vue?vue&type=script&lang=ts"
export * from "./TheCategoryTipology.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports